import { DisplayPosition } from '@/type/display-position';
import { getMaxLengthSetterSnippet } from '@/common/manager/setter-snippet';
// import { componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '长文本输入',
    componentName: 'CnInputTextArea',
    // formComponent: formComponentMap.CnInputTextArea,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请输入',
        };
    },
    getPrototypeList: () => {
        return [getMaxLengthSetterSnippet()];
    },
};
